export default {
  primary: "https://insights.shapegamesbwwebtest.com",
  secondary: "https://insights-link.shapegamesbwwebtest.com",
};
